export enum KeyEvent {
    UP ='Up',
    TAB ='Tab',
    DOWN = 'Down',
    ENTER = 'Enter',
    ARROWUP ='ArrowUp',
    ARROWDOWN ='ArrowDown'
}
